export default __webpack_public_path__ + "static/Pala_7-c5eaf7f9e5508c8725f016ad4a3b701e.png";